import { TeamMember } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamMemberRoleUpdateReq, teamApi } from '../api';
import { TEAM_DAY_QUERY_KEY, TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface UpdateTeamMemberRoleParams {
  teamId: string;
  memberUserId: string;
  teamMemberRoleUpdateReq: TeamMemberRoleUpdateReq;
}

export const useUpdateTeamMemberRole = () => {
  const queryClient = useQueryClient();

  const updateTeamMemberRoleMutation = useMutation({
    mutationFn: ({ teamId, memberUserId, teamMemberRoleUpdateReq }: UpdateTeamMemberRoleParams) => {
      return teamApi
        .updateTeamMemberRole(teamId, memberUserId, teamMemberRoleUpdateReq)
        .then(({ data }) => data.membership as TeamMember);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DAY_QUERY_KEY });
    },
  });

  return {
    updateTeamMemberRole: updateTeamMemberRoleMutation.mutateAsync,
    isUpdatingTeamMemberRole: updateTeamMemberRoleMutation.isPending,
    ...updateTeamMemberRoleMutation,
  };
};
